import React, { Component } from 'react';
import classNames from 'classnames';
import { AppTopbar } from '../../AppTopbar';
import { AppBreadcrumb } from "../../AppBreadcrumb";
import { AppInlineProfile } from '../../AppInlineProfile';
import { AppFooter } from '../../AppFooter';
import { AppMenu } from '../../AppMenu';
import { Route } from 'react-router-dom'
import { Password } from 'primereact/password';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';
import { Message } from 'primereact/message';
import { ScrollPanel } from 'primereact/components/scrollpanel/ScrollPanel';
import { withRouter } from 'react-router';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import '../../ripple.js';
import '../../App.css';

import servicioMenu from '../servicios/ServicioMenu';
import servicioUsuario from '../servicios/ServicioUsuario';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';

import { Cfdi } from './Cfdi';
import { ModificacionDatosUsuario } from './ModificacionDatosUsuario';
import { FacturacionRegistro } from './FacturacionRegistro';
import { Emisor } from './Emisor';
import { FacturacionPagos } from './FacturacionPagos';
import { ConsultaCfdiAdmin } from './ConsultaCfdiAdmin';
import { FacturacionEmergencia } from './FacturacionEmergencia';
import { Parametros } from './Parametros';
import { PlazaCobro } from './PlazaCobro';
import { AdministracionUsuarios } from './AdministracionUsuarios';
import Recaptcha from 'react-recaptcha';
import { Carril } from './Carril';
import { PeriodoIva } from './PeriodoIva';
import { Perfil } from './Perfil';
import { Sucursal } from './Sucursal';
import { FacturacionLayout } from './FacturacionLayout';
import { Materiales } from './Materiales';
import { ConsultaFacturacionLayout } from './ConsultaFacturacionLayout';
import { Cancelacion } from './Cancelacion';
import { ConsultaReportes } from './ConsultaReportes';
import { Serie } from './Serie';
import { MetodoPago } from './MetodoPago';
import { ReporteFacturacion } from './ReporteFacturacion';
import { FacturacionOtrosIngresos } from './FacturacionOtrosIngresos';
import { ConsultaFacturasOrigen } from './ConsultaFacturasOrigen';
import { ConsultaComprobantePago } from './ConsultaComprobantePago';
import { Funcionalidad } from './Funcionalidad';
import { ConsultaLineaExpress } from './ConsultaLineaExpress';
import { FacturacionLayoutTelepeaje } from './FacturacionLayoutTelepeaje';
import { CfdiLayoutTelepeaje } from './CfdiLayoutTelepeaje';
import { AdministracionTicket } from './AdministracionTicket';
import { ConsultaCfdiTelepeajeUsuario } from './ConsultaCfdiTelepeajeUsuario';
import { CorrecionFacturasPeaje } from './CorrecionFacturasPeaje';
import { ComparacionPagosTelepeaje } from './ComparacionPagosTelepeaje';
import { ReporteFacturacionMensual } from './ReporteFacturacionMensual';
import { FacturacionLineaExpress } from './FacturacionLineaExpress';
import { BuscarFacturaCancelada } from './BuscarFacturaCancelada';
class Bienvenido extends Component {

    constructor() {
        super();
        this.state = {
            layoutMode: 'static',
            profileMode: 'inline',
            overlayMenuActive: false,
            staticMenuDesktopInactive: false,
            staticMenuMobileActive: false,
            rotateMenuButton: false,
            topbarMenuActive: false,
            activeTopbarItem: null,
            darkMenu: false,
            rightPanelActive: false,
            menuActive: false,
            menu: [],
            usuario: {},
            mostrarModalContrasenia: false,
            confirma: null,
            errores: {},
            verificaCapchap: false
        };

        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onMenuClick = this.onMenuClick.bind(this);
        this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
        this.onTopbarMenuButtonClick = this.onTopbarMenuButtonClick.bind(this);
        this.onTopbarItemClick = this.onTopbarItemClick.bind(this);
        this.onMenuItemClick = this.onMenuItemClick.bind(this);
        this.onRootMenuItemClick = this.onRootMenuItemClick.bind(this);
        this.onRightPanelButtonClick = this.onRightPanelButtonClick.bind(this);
        this.onRightPanelClick = this.onRightPanelClick.bind(this);
        this.verificaCapchaCorrecto = this.verificaCapchaCorrecto.bind(this);
        this.createMenu();
    }

    componentDidMount() {
        this.validaCambioContrasena();
    }
    recaptchaLoad() {
        console.log("captchap");
    }
    verificaCapchaCorrecto(response) {
        if (response) {
            this.setState({
                verificaCapchap: true
            });
        }
    }

    validaCambioContrasena() {
        // servicioUsuario.verificaEstatus().then((response) => {
        //     if (response.data.error === true) {
        //         this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos vuelve a intentarlo más tarde' });
        //         //window.location = "/Capufe"
        //     }

        //     if (response.data.mensaje.includes("true")) {
        //         this.setState({ mostrarModalContrasenia: true });
        //     }

        // }).catch((error) => {
        //     console.log("Bienvenido error: ",error);
        //     // if (error)
        //     //     window.location = "/Capufe"
        // });
    }


    onMenuClick(event) {
        this.menuClick = true;
    }

    onMenuButtonClick(event) {
        this.menuClick = true;
        this.setState(({
            rotateMenuButton: !this.state.rotateMenuButton,
            topbarMenuActive: false
        }));

        if (this.state.layoutMode === 'overlay') {
            this.setState({
                overlayMenuActive: !this.state.overlayMenuActive
            });
        }
        else {
            if (this.isDesktop())
                this.setState({ staticMenuDesktopInactive: !this.state.staticMenuDesktopInactive });
            else
                this.setState({ staticMenuMobileActive: !this.state.staticMenuMobileActive });
        }

        event.preventDefault();
    }

    onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.setState({ topbarMenuActive: !this.state.topbarMenuActive });
        this.hideOverlayMenu();
        event.preventDefault();
    }

    onTopbarItemClick(event) {
        this.topbarItemClick = true;

        if (this.state.activeTopbarItem === event.item)
            this.setState({ activeTopbarItem: null });
        else
            this.setState({ activeTopbarItem: event.item });

        event.originalEvent.preventDefault();
    }

    onMenuItemClick(event) {
        if (!event.item.items) {
            this.hideOverlayMenu();
        }

        if (!event.item.items && (this.isHorizontal() || this.isSlim())) {
            this.setState({
                menuActive: false
            })
        }

        if (event.item.items && !this.isHorizontal() && this.layoutMenuScroller) {
            setTimeout(() => {
                this.layoutMenuScroller.moveBar();
            }, 500);
        }
    }

    onRootMenuItemClick(event) {
        this.setState({
            menuActive: !this.state.menuActive
        });
    }

    onRightPanelButtonClick(event) {
        this.rightPanelClick = true;
        this.setState({
            rightPanelActive: !this.state.rightPanelActive
        });
        event.preventDefault();
    }

    onRightPanelClick(event) {
        this.rightPanelClick = true;
    }

    onDocumentClick(event) {
        if (!this.topbarItemClick) {
            this.setState({
                activeTopbarItem: null,
                topbarMenuActive: false
            });
        }

        if (!this.menuClick) {
            if (this.isHorizontal() || this.isSlim()) {
                this.setState({
                    menuActive: false
                })
            }

            this.hideOverlayMenu();
        }

        if (!this.rightPanelClick) {
            this.setState({
                rightPanelActive: false
            })
        }

        this.topbarItemClick = false;
        this.menuClick = false;
        this.rightPanelClick = false;
    }

    hideOverlayMenu() {
        this.setState({
            rotateMenuButton: false,
            overlayMenuActive: false,
            staticMenuMobileActive: false
        })
    }

    isTablet() {
        let width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    isMobile() {
        return window.innerWidth <= 640;
    }

    isOverlay() {
        return this.state.layoutMode === 'overlay';
    }

    isHorizontal() {
        return this.state.layoutMode === 'horizontal';
    }

    isSlim() {
        return this.state.layoutMode === 'slim';
    }


    createMenu() {
        let { menu } = this.state;
        servicioMenu.obtenerMenu().then((response) => {
            let arregloMenu = response.data;
            for (var i = 0; i < arregloMenu.length; i++) {
                menu.push(arregloMenu[i]);
            }
            this.setState({ menu: menu });
        }).catch((error) => {

        });


        /*   this.menu = [
               {label: 'Dashboard', icon: 'dashboard', to: '/facturacioncapufe/bienvenido'},
             
           ];*/
    }

    asignarValores(event) {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    }

    validarCambioContrasena(usuario, confirma) {

        const errores = {};
        let patronSeguro = new RegExp("^(?=.{7,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$", "g");

        if (!usuario.contrasena)
            errores.contrasena = "El campo es requerido";
        if (!confirma)
            errores.confirma = "El campo es requerido";
        if (confirma !== usuario.contrasena)
            errores.contrasena = "Las constraseñas no coinciden";

        if (usuario.contrasena.length < 7) {
            errores.contrasena = "La longitud debe ser mayor o igual a 7.";
            return errores;
        }

        if (!patronSeguro.test(usuario.contrasena))
            errores.contrasena = "contrasena insegura.";

        return errores;
    }

    cambiarContrasena() {
        let { usuario, confirma, verificaCapchap } = this.state;

        const resultadoValidacion = this.validarCambioContrasena(usuario, confirma);
        this.setState({ errores: resultadoValidacion });

        if (!Object.keys(resultadoValidacion).length) {
            if (verificaCapchap === true) {
                servicioUsuario.actualizarContrasena(usuario).then((response) => {
                    this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

                    if (response.data.error === false)
                        setTimeout(function () { this.resetEstados(); }.bind(this), 3000);

                }).catch((error) => { this.resetEstados(); });
            } else {
                this.growl.show({ severity: 'error', summary: 'Error', detail: 'Selecciona captcha' });
            }
        }
    }

    resetEstados() {
        this.setState({ usuario: {}, mostrarModalContrasenia: false, confirma: null, errores: {} })
    }

    cerrarSession() {
        this.setState({ mostrarModalContrasenia: false });
        localStorage.removeItem("auth");
        window.location = '/Capufe';
    }

    render() {

        const { menu } = this.state;
        let { usuario, errores, confirma } = this.state;

        const encabezadoCambiarContrasena = <div className="encabezado">
            <center>  <strong className="textoBlanco">
                ¡Por seguridad es importante que actualice su contraseña!
                      </strong>
            </center>
        </div>

        const pieCambiarContrasena = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Aceptar" icon="pi-md-check" onClick={this.cambiarContrasena.bind(this)} />
            <Button label="Cancelar" icon="pi-md-close" className="p-button-danger " onClick={this.resetEstados.bind(this)} />
        </div>;

        const layoutContainerClassName = classNames('layout-container', {
            'menu-layout-static': this.state.layoutMode !== 'overlay',
            'menu-layout-overlay': this.state.layoutMode === 'overlay',
            'layout-menu-overlay-active': this.state.overlayMenuActive,
            'menu-layout-slim': this.state.layoutMode === 'slim',
            'menu-layout-horizontal': this.state.layoutMode === 'horizontal',
            'layout-menu-static-inactive': this.state.staticMenuDesktopInactive,
            'layout-menu-static-active': this.state.staticMenuMobileActive
        });
        const menuClassName = classNames('layout-menu', { 'layout-menu-dark': this.state.darkMenu });
        const AppBreadCrumbWithRouter = withRouter(AppBreadcrumb);

        return (

            <div className="layout-wrapper" onClick={this.onDocumentClick}>
                <div ref={(el) => this.layoutContainer = el} className={layoutContainerClassName}>
                    <AppTopbar profileMode={this.state.profileMode} horizontal={this.isHorizontal()}
                        topbarMenuActive={this.state.topbarMenuActive} activeTopbarItem={this.state.activeTopbarItem}
                        onMenuButtonClick={this.onMenuButtonClick} onTopbarMenuButtonClick={this.onTopbarMenuButtonClick}
                        onTopbarItemClick={this.onTopbarItemClick} onRightPanelButtonClick={this.onRightPanelButtonClick} />

                    <div className={menuClassName} onClick={this.onMenuClick}>
                        <ScrollPanel ref={(el) => this.layoutMenuScroller = el} style={{ height: '100%' }}>
                            <div className="menu-scroll-content">
                                {(this.state.profileMode === 'inline' && this.state.layoutMode !== 'horizontal') && <AppInlineProfile />}
                                <AppMenu model={menu} onMenuItemClick={this.onMenuItemClick} onRootMenuItemClick={this.onRootMenuItemClick}
                                    layoutMode={this.state.layoutMode} active={this.state.menuActive} />
                            </div>
                        </ScrollPanel>
                    </div>

                    <div className="layout-main">

                        <AppBreadCrumbWithRouter />

                        <div className="layout-content">
                            <Route path="/Capufe/bienvenido/envio" component={Cfdi} />
                            <Route path="/Capufe/bienvenido/usuario" component={ModificacionDatosUsuario} />
                            <Route path="/Capufe/bienvenido/ticket" component={FacturacionRegistro} />
                            <Route path="/Capufe/bienvenido/emisores" component={Emisor} />
                            <Route path="/Capufe/bienvenido/pagos" component={FacturacionPagos} />
                            <Route path="/Capufe/bienvenido/consultaAdmin" component={ConsultaCfdiAdmin} />
                            <Route path="/Capufe/bienvenido/emergencia" component={FacturacionEmergencia} />
                            <Route path="/Capufe/bienvenido/plaza" component={PlazaCobro} />
                            <Route path="/Capufe/bienvenido/parametros" component={Parametros} />
                            <Route path="/Capufe/bienvenido/usuarios" component={AdministracionUsuarios} />
                            <Route path="/Capufe/bienvenido/carril" component={Carril} />
                            <Route path="/Capufe/bienvenido/impuestos" component={PeriodoIva} />
                            <Route path="/Capufe/bienvenido/perfilUsuario" component={Perfil} />
                            <Route path="/Capufe/bienvenido/sucursal" component={Sucursal} />
                            <Route path="/Capufe/bienvenido/layout" component={FacturacionLayout} />
                            <Route path="/Capufe/bienvenido/materiales" component={Materiales} />
                            <Route path="/Capufe/bienvenido/envioLayout" component={ConsultaFacturacionLayout} />
                            <Route path="/Capufe/bienvenido/cancelacion" component={Cancelacion} />
                            <Route path="/Capufe/bienvenido/consultas" component={ConsultaReportes} />
                            <Route path="/Capufe/bienvenido/series" component={Serie} />
                            <Route path="/Capufe/bienvenido/metodoPago" component={MetodoPago} />
                            <Route path="/Capufe/bienvenido/reportesFacturacion" component={ReporteFacturacion} />
                            <Route path="/Capufe/bienvenido/diversos" component={FacturacionOtrosIngresos} />
                            <Route path="/Capufe/bienvenido/adminPagos" component={ConsultaFacturasOrigen} />
                            <Route path="/Capufe/bienvenido/consultapago" component={ConsultaComprobantePago} />
                            <Route path="/Capufe/bienvenido/funcionalidad" component={Funcionalidad} />
                            <Route path="/Capufe/bienvenido/lineaexpress" component={ConsultaLineaExpress} />
                            <Route path="/Capufe/bienvenido/layouttelepeaje" component={FacturacionLayoutTelepeaje} />
                            <Route path="/Capufe/bienvenido/cfditelepeaje" component={CfdiLayoutTelepeaje} />
                            <Route path="/Capufe/bienvenido/adminticket" component={AdministracionTicket} />
                            <Route path="/Capufe/bienvenido/cfditelepeajeusuario" component={ConsultaCfdiTelepeajeUsuario} />
                            <Route path="/Capufe/bienvenido/coreccionfacturaspeaje" component={CorrecionFacturasPeaje} />
                            <Route path="/Capufe/bienvenido/comparacionpagostelepeaje" component={ComparacionPagosTelepeaje} />
                            <Route path="/Capufe/bienvenido/reportemensualfacturacion" component={ReporteFacturacionMensual} />
                            <Route path="/Capufe/bienvenido/facturacionlineaexpress" component={FacturacionLineaExpress}></Route>
                            <Route path="/Capufe/bienvenido/facturacancelada" component={BuscarFacturaCancelada}></Route>
                            <AppFooter />
                        </div>
                    </div>

                    <div className="content-section implementation">

                        <Growl ref={(el) => this.growl = el} />

                        <Dialog visible={this.state.mostrarModalContrasenia} style={{ width: '60%' }} modal={true} header={encabezadoCambiarContrasena} footer={pieCambiarContrasena} onHide={this.cerrarSession.bind(this)}>
                            <div className="p-grid">

                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="contrasenia">*Contraseña</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">lock_open</i></span>
                                        <Password id="contrasena" name="usuario.contrasena" className={errores.contrasena ? 'p-error' : ''} value={usuario.contrasena || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.contrasena ? <div><br /> <Message severity="error" text={errores.contrasena} /> </div> : null}
                                </div>

                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="confirma">*Confirmar Contraseña</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <div className="p-inputgroup">
                                        <span className="p-inputgroup-addon"><i className="material-icons">lock_open</i></span>
                                        <Password id="confirma" name="confirma" className={errores.confirma ? 'p-error' : ''} value={confirma || ''} onChange={(e) => { this.setState({ confirma: e.target.value }) }} style={{ width: '100%' }} />
                                    </div>
                                    {errores.confirma ? <div><br /> <Message severity="error" text={errores.confirma} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-4">
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <Recaptcha sitekey="6LePa7UUAAAAABwcnOacAhKLhiTzPWZ8MT-ya6Ok" render="explicit" onloadCallback={this.recaptchaLoad} verifyCallback={this.verificaCapchaCorrecto} />
                                </div>
                            </div>
                        </Dialog>
                    </div>


                    <div className="layout-mask"></div>
                </div>
            </div>
        );
    }
}

export default Bienvenido;